<template>
<div class="main my">
  <!-- 私教课管理 -->
  <van-search placeholder="请输入搜索关键词" v-model="value" @search="search()" @clear="search()"/>
  <div v-if="role != 'coach'" class="clear mbm mtn mrm">
    <van-button class="right" type="primary" size="small" @click="scanCode()">+ 添加私教课</van-button>
  </div>
  <div class="bcw">
    <!-- 列表 -->
    <van-swipe-cell :right-width="65" v-for="(item,index) in list" :key="index" class="cell-item bcw  pbn ptn bob clear">
      <van-cell-group class="clear">
        <div class="cell-item__img" @click="goHomepage(item.userId)">
          <img :src="item.avatar">
        </div>
        <van-cell class="cell-item__cell" :center="true" :value="'剩余'+item.remainingNum+'课时'" is-link :to="'/privatecoursetimetable?id='+item.id+'&num='+item.remainingNum">
          <template slot="title">
            <span class="custom-text">{{item.nickname}}</span>
            <van-tag type="success" size="mini">课表</van-tag>
            <p class="custom-text c6 fs2" style="margin-top:2px;"> <van-icon name="phone-o" style="float:left;margin:6px 1px 0 0;" />电话:{{item.verifiedMobile}}</p>
          </template>
        </van-cell>
      </van-cell-group>
      <span class="right_del" slot="right" @click="handleDel(index,item.orderId)">删除</span>
    </van-swipe-cell>

    <div v-if="list.length==0" v-show="none" class="tac c9 fs2 ptm pbm">~ 暂无记录 ~</div>
    <div v-if="list.length!=0 && listTotal>pageSize" class="tac c9 bcw ptm pbw" @click="loadMore()" v-show="loadShow">{{loadTxt}}</div>
    <!-- //列表 -->
  </div>
</div>
</template>
<script>
import Vue from 'vue';
import func from "@/assets/scripts/func";
import wx from "weixin-js-sdk";
import weChat from "@/assets/scripts/wechat";

import moment from 'moment';
moment.locale('zh-cn');
import {
  Cell, CellGroup,Checkbox, CheckboxGroup,SwitchCell, Toast,SwipeCell
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Checkbox).use(CheckboxGroup).use(SwitchCell).use(Toast).use(SwipeCell);



export default {
  components: {
  },
  filters: {
    formatTime: function(value) {
      return moment(value*1000).format('YYYY/MM/DD')+' 购买';
    }
  },
  data() {
    return {
      list:[],
      page: 1,
      pageSize: 15,
      loadShow: true,
      loadTxt: "加载更多",
      listTotal:'', //列表总数
      none:false,
      value:'',
      role: this.$route.query.role  //判断角色是否为coach
    }
  },
  created(){
    // 获取私教课列表
    this.fetchData()
  },
  methods: {
    goHomepage: function(id) {
      location.href =`${location.origin}` + "/training/#/userHome?userId=" + id;
    },
    fetchData(keywords,more) {
      // 获取私教课列表
      this.$http.post('club_pt_course_manage/getList',{
        keywords:keywords,
        page: this.page,
        limit: this.pageSize
      }).then(res => {
        if (!res.data.code) {
          let re = res.data.value;
          this.listTotal = re.total
          if(more=='more'){
            //是 加载更多
            this.list = this.list.concat(re.list);
            this.loadTxt = "加载更多";
            if (re.list.length < this.pageSize) {
              this.loadShow = false;
            } 
          }else{
            //否 加载更多
            this.list = re.list
          }                   
        } else {
          Toast.fail(res.data.message);
          this.loadTxt = "加载更多";
        }

        this.none = true //解决“暂无记录”默认显示的问题
      })
    },
    loadMore() {
      //加载更多
      this.loadTxt = "正在加载";
      this.page++;
      this.fetchData(this.value,'more');
    },
    scanCode() {
      let _this = this
      weChat.wxConfig().then(() => {
        // 扫一扫
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: function(res) {
            //console.log(res.resultStr); // 当needResult 为 1 时，扫码返回的结果
            // alert(res.resultStr)
            // 跳转到添加页面
            _this.$router.push({path: 'privatecourseadd',query:{'userId':res.resultStr}})
          }
        });
      });
    },
    search(){
      // 搜索
      this.page = 1
      this.loadShow = true; //加载更多状态还原
      this.fetchData(this.value)
    },
    handleDel(index,id){
      // 删除
      let _this = this
      this.$http.post('order_manage/refund',{
          orderId: id
      }).then(function(res){
          if(res.data.code == 0){
            _this.list.splice(index,1)
            _this.fetchData(_this.value)
          }else{
            Toast(res.data.message)
          }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.my-model{
  padding: .1rem 0; 
}
.cell-item{
  &__img{
    float: left;
    width: .4rem;
    height: .4rem;
    margin: .1rem 0 0 .1rem;
    border-radius: 50%;
    overflow: hidden;
    &>img{
      width: 100%;height: 100%;object-fit: cover;
    }
  }
  &__cell{
    float: left;
    width: calc(100% - 0.5rem);
    padding: .08rem .1rem;
  }
}

// 左滑删除按钮
.right_del{
  height:.66rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/manage/PrivateCourseList.vue